import {
    ACT_EMP_ADD_201,
    ACT_EMP_ADD_INIT,
    ACT_EMP_FETCH_200,
    ACT_EMP_FETCH_INIT,
    ACT_EMP_UPDATE_INIT,
    ACT_EMP_UPDATE_200,
    ACT_EMP_DELETE,
} from "../constants/actions";

export const fetchEmployeesInitAction = () => ({
    type: ACT_EMP_FETCH_INIT,
});

export const fetchEmployeesSuccessAction = (employees) => ({
    type: ACT_EMP_FETCH_200,
    employees,
});

export const addEmployeeInitAction  = (employeeToAdd) => ({
    type: ACT_EMP_ADD_INIT,
    employeeToAdd,
});

export const addEmployeeSuccessAction = (employee) => ({
    type: ACT_EMP_ADD_201,
    employee,
});

export const editEmployeeInitAction = (id, employeeData) => ({
    type: ACT_EMP_UPDATE_INIT,
    id,
    employeeData,
});
  
export const editEmployeeSuccessAction = (employee) => ({
    type: ACT_EMP_UPDATE_200,
    employee,
});